import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 transition-opacity bg-gray-900 bg-opacity-75" }, null, -1)
const _hoisted_3 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_4 = { class: "flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0" }
const _hoisted_5 = { class: "relative w-full overflow-hidden text-left transition-all transform bg-white rounded shadow sm:my-8 sm:w-full sm:max-w-lg" }
const _hoisted_6 = { class: "bg-white" }
const _hoisted_7 = { class: "flex items-center justify-between border-b border-gray-400" }
const _hoisted_8 = { class: "w-full px-2 py-4 text-left" }
const _hoisted_9 = {
  class: "text-lg font-medium leading-6 text-gray-900",
  id: "modal-title"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-x-lg",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" })
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onSubmit"]
const _hoisted_13 = { class: "mt-4 space-y-1" }
const _hoisted_14 = { class: "mt-4 font-medium capitalize" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "mt-4 space-y-1" }
const _hoisted_17 = { class: "mt-4 font-medium capitalize" }
const _hoisted_18 = { class: "mt-4 space-y-1" }
const _hoisted_19 = { class: "mt-2 font-medium capitalize" }
const _hoisted_20 = { class: "block text-sm" }
const _hoisted_21 = { class: "block space-x-2" }
const _hoisted_22 = { class: "inline-block pl-[0.15rem]" }
const _hoisted_23 = { class: "flex justify-center px-4 py-3 bg-gray-50" }

import { PropType, ref, watch } from "vue";

import DefaultButton from "../DefaultButton.vue";

import { ClubDate, StudentNote } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'StudentNoteModal',
  props: {
  isOpen: {
    type: Boolean,
    required: true,
  },
  mode: {
    type: String,
    required: true,
  },
  note: {
    type: Object as PropType<StudentNote | null>,
    required: false,
  },
  dates: {
    type: Array as PropType<ClubDate[]>,
  },
  isSavingNote: {
    type: Boolean,
    required: true,
  },
},
  emits: ["close", "create", "update"],
  setup(__props, { emit: emits }) {

const props = __props;




const content = ref("");
const session_id = ref();
const show_parent = ref(false);

function close() {
  emits("close");
}

function saveNote() {
  if (props.mode === "create") {
    /** Create note */
    return emits("create", session_id.value, content.value, show_parent.value);
  }

  /** Update existing note */
  return emits("update", props.note!.id, session_id.value, content.value, show_parent.value);
}

watch(
  () => props.isOpen,
  () => {
    if (props.isOpen && props.note) {
      content.value = props.note?.content;
      session_id.value = props.note?.brick_club_date_id;
      show_parent.value = props.note?.show_parent;
    } else {
      content.value = "";
      session_id.value = 0;
      show_parent.value = false;
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (props.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t("brick-club-note-for-member")), 1)
                  ]),
                  _createElementVNode("div", { class: "py-4 pl-2 pr-4" }, [
                    _createElementVNode("button", { onClick: close }, _hoisted_11)
                  ])
                ]),
                _createElementVNode("form", {
                  class: "px-4 pb-8 mt-4 border-b border-gray-400",
                  onSubmit: _withModifiers(saveNote, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("session")), 1),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((session_id).value = $event)),
                      class: "text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.dates, (date, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: date.id,
                          key: index
                        }, _toDisplayString(date.start_time) + " on " + _toDisplayString(new Date(date.date).toLocaleDateString()), 9, _hoisted_15))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, session_id.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("note")), 1),
                    _withDirectives(_createElementVNode("textarea", {
                      type: "text",
                      name: "note",
                      id: "note",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((content).value = $event)),
                      class: "text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-400",
                      required: ""
                    }, null, 512), [
                      [_vModelText, content.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("show-members-parent-carer")), 1),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('notes-only-visible')), 1),
                    _createElementVNode("div", _hoisted_21, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        name: "show_parent",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((show_parent).value = $event)),
                        value: false,
                        class: "rounded hover:cursor-pointer"
                      }, null, 512), [
                        [_vModelCheckbox, show_parent.value]
                      ]),
                      _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("visible-to-members-parent-carer")), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(DefaultButton, {
                      type: "primary",
                      "is-form-submit": true,
                      disabled: __props.isSavingNote,
                      loading: __props.isSavingNote
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("save")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading"])
                  ])
                ], 40, _hoisted_12)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})